import { NO_UPPER_LIMIT_OPTION } from '../constants';

export const getUpperLimitOptionFromValue = (
  upperLimit?: number | null,
  recommendedUpperLimit?: number | null,
): number => {
  if (upperLimit === null) {
    return NO_UPPER_LIMIT_OPTION;
  }

  if (!!upperLimit) {
    return upperLimit;
  }

  if (!recommendedUpperLimit) {
    return NO_UPPER_LIMIT_OPTION;
  }

  return recommendedUpperLimit;
};
